import "../Legal/styles.css";

const ThreeDPrintLicensing = () => {
  return (
    <div className="legal-page">
      <h1 className="legal-title">3D Print Licensing</h1>

      <section className="legal-content">
        <h2>Hogcloud Designs</h2>
        <p>
          All original Hogcloud 3D print designs, models, product layouts,
          digital files, photographs, product listings, and related design
          materials are protected by the Hogcloud Standard Digital License.
        </p>
        <p>
          Unless Hogcloud gives written permission otherwise, Hogcloud designs
          may not be copied, resold, redistributed, uploaded to another model
          marketplace, remixed for resale, used to create competing digital
          files, or represented as another creator&apos;s work.
        </p>
      </section>

      <section className="legal-content">
        <h2>Finished Printed Products</h2>
        <p>
          Customers may use finished physical 3D printed products purchased from
          Hogcloud for personal, gift, display, promotional, or ordinary
          business use. Purchasing a finished print does not transfer ownership
          of the underlying digital model, design file, or production workflow.
        </p>
      </section>

      <section className="legal-content">
        <h2>External Creator Licenses</h2>
        <p>
          Some Hogcloud prints may be produced from designs by external creators
          where Hogcloud maintains an active commercial or maker license. Those
          designs remain subject to the creator&apos;s license terms, membership
          tier, and any current usage restrictions.
        </p>
        <ul>
          <li>
            Wiggle3D:{' '}
            <a
              href="https://www.patreon.com/cw/Wiggle3D"
              rel="noopener noreferrer"
              target="_blank"
            >
              https://www.patreon.com/cw/Wiggle3D
            </a>
          </li>
          <li>
            JIMGA:{' '}
            <a
              href="https://makerworld.com/en/@JIMGA"
              rel="noopener noreferrer"
              target="_blank"
            >
              https://makerworld.com/en/@JIMGA
            </a>
          </li>
        </ul>
      </section>

      <section className="legal-content">
        <h2>Questions</h2>
        <p>
          For questions about a specific design, commercial use, attribution, or
          whether a print is based on a Hogcloud original design or an external
          creator license, contact Hogcloud before reproducing, reselling, or
          distributing the item.
        </p>
      </section>
    </div>
  );
};

export default ThreeDPrintLicensing;
